/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   location utilities
 */

type BoxTuple = readonly [minLng: number, minLat: number, maxLng: number, maxLat: number]

export interface Box {
  readonly minLng: number
  readonly minLat: number
  readonly maxLng: number
  readonly maxLat: number
}

/**
 * convert box array: [minLng,minLat,maxLng,maxLat] to object form
 *
 * @param box
 */
export const boxToQueryBounds = (box: BoxTuple): Box => {
  return {
    minLng: box[0],
    minLat: box[1],
    maxLng: box[2],
    maxLat: box[3],
  }
}
